import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Typography, Slide, Link } from "@mui/material";
import { NavLink } from "react-router-dom";

const CONTACTS_PATH = "/contacts"; // Путь к странице контактов

const Sales = () => {
  const theme = useTheme();

  return (
    <Slide direction="left" in timeout={1000}>
      <Box
        sx={{
          backgroundColor: theme.palette.mode === "dark" ? "#222" : "#fff",
          color: theme.palette.mode === "dark" ? "#fff" : "#000",
          padding: "20px",
          borderRadius: "8px",
          textAlign: "center",
          boxShadow: theme.palette.mode === "dark" 
            ? "0px 4px 10px rgba(255, 255, 255, 0.1)" 
            : "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          🔥 АКЦИЯ ВЫХОДНОГО ДНЯ! 🔥
        </Typography>
        <Typography>
          💥 Купи 1 – получи 2! 💥
        </Typography>
        <Typography mt={2}>
          📅 Все выходные начиная с пятницы!
        </Typography>
        <Typography mt={2}>
          🛒 Оформляй заказ на сайте или через операторов, оплачивай – и получай второй товар в подарок! 🎁
        </Typography>
        <Typography mt={2}>
          ⚡ Идентичный товар – бесплатно! ⚡
        </Typography>
        <Typography mt={2}>
          ❗ Успей воспользоваться предложением, пока оно действует! ❗
        </Typography>
        <Typography mt={2} fontWeight="bold" color={theme.palette.mode === "dark" ? "#ffcc00" : "#d32f2f"}>
          📩 Пиши в ЛС одному из операторов во вкладке <Link component={NavLink} to={CONTACTS_PATH}>{"Контакты"}</Link> или покупай на сайте прямо сейчас! 🚀
        </Typography>
      </Box>
    </Slide>
  );
};

export default Sales;
